import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { hideLoader, showLoader } from '../../../../../components/loader';
import { createFormdataValues } from '../../../../../utils/createFormdataValues';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import ErrorMessage from '../../../../../components/errors/errorMessage';
import { apiUrl } from '../../../../../utils/url';

const ExportFormModal = ({ show, title, exportToSteps, setExportToSteps, handleSave, buttonText }) => {
    const [error, setError] = useState([]);
    const { slug } = useSelector(state => state?.slugReducer);
    const [instantly_campaign, setinstantly_campaign] = useState([]);
    const handleClose = () => {
        setExportToSteps(null);
    }
    const handleChange = (e) => {
        setExportToSteps({ ...exportToSteps, [e.target.name]: e.target.value });
    }
    const inputs = {
        google_sheets: [
            {
                label: 'Spreadsheet URL',
                name: 'export_to_data',
                type: 'url',
                placeholder: 'Enter URL',
                required: true,
            }
        ],
        instantly: [
            {
                label: 'Campaign',
                name: 'instantly_campaign',
                dropdown: true,
                options: instantly_campaign
            }
        ],
    };
    const handleSubmit = (e) => {
        e?.preventDefault();
        handleSave();
    }
    const handleSelectValue = (val,name) => {
        setExportToSteps({ ...exportToSteps, "export_to_data": val });
    };
    useEffect(()=>{
        if(exportToSteps?.export_to == 'instantly'){
            getCampaigns();
        }
    },[])
    const getCampaigns = async () => {
        try {
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
            const res = await fetch(`${apiUrl}/get-instantly-campaigns/${slug}`, {
                headers: myHeaders
            })
            const response = await res.json();
            if (response.status_code === 200) {   
                setinstantly_campaign(response?.data);
            }else{
                toast.error(response.status_message);
            }
        }
        catch (err) {
            toast.error(err);
        }
    }
    return (
        <Modal centered show={show} onHide={handleClose} className="rename-modal">
            <div class="modal-content pt-0 pl-0 pr-0 pb-0 border-0 ">
                <div class="modal-header">
                    <span onClick={() => setExportToSteps({ step: 1 })} className='me-2 cursor-pointer'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
                            <path d="M12.6569 5.34315L1.34315 5.34315M1.34315 5.34315L5.11438 9.11438M1.34315 5.34315L5.11438 1.57191" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                    {title}
                    <button type="button" class="close" onClick={handleClose} aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form action="" id="" method="post" role="form" onSubmit={handleSubmit}>
                        <ErrorMessage error={error} />
                        <div className='form-group'>
                            {
                                inputs?.[exportToSteps?.export_to]?.map((val, index) => (
                                    <div key={index}>

                                        {
                                            val?.label &&
                                            <label className='fs-12 font-weight-500' htmlFor="">{val?.label}</label>
                                        }
                                        {
                                            val?.dropdown ?
                                            <>
                                            <div class="table-action-dropdown p-1 d-flex justify-content-between align-items-center gap-2 cursor-pointer zaapGlobal-input dropdown-toggle noselect dropdown-subscribers" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false" >
                                                <span className="d-flex align-items-center gap-2">
                                                {exportToSteps?.[val?.name] || 'Choose Campaign'}
                                                </span>
                                            </div>
                                            <ul class="dropdown-menu brand-dropdown-menu" aria-labelledby="table-action-dropdown">
                                            {val?.options?.length > 0 && (
                                                val?.options?.map((option, idx) => (
                                                    <li key={idx} onClick={() => handleSelectValue(option?.name,val)}>
                                                        <a className="dropdown-item cursor-pointer border-radius-9">
                                                            <span>{option?.name}</span>
                                                        </a>
                                                    </li>
                                                ))
                                            )}
                                            </ul>
                                            </>
                                            :
                                            <>
                                                <input {...val} onChange={handleChange} className='zaapGlobal-input h-30px bg-f3f3f3' value={val?.[name]} />
                                            </>
                                        }
                                    </div>
                                ))
                            }
                            {/* <input type="text" name="name" onChange={handleChange} className='zaapGlobal-input h-30px bg-f3f3f3' value={value?.name} /> */}
                        </div>
                        <div className='d-flex gap-2 mt-20px p-0 align-items-center justify-content-center new-modal-footer'>
                            <button onClick={handleClose} className='fs-12 w-50 mt-0 integration-btns integration-btn-grey' type='button'>Cancel</button>
                            <button className='fs-12 w-50 shadow-none  project-blue-btn' type='submit'>{buttonText ?? 'Import'}</button>
                        </div>
                    </form>

                </div>
            </div>
        </Modal>
    )
}
export default ExportFormModal;